import { motion } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";
import { SectionHead, FadeIn } from "./Reveal";

const SERVICES = [
  {
    id: 0,
    tag: "Montaż / 01",
    title: "Subwoofer i wzmacniacz",
    desc: "Solidne podłączenie pod fabryczne lub niefabryczne radia — z pełnym zabezpieczeniem instalacji.",
    features: [
      "Podłączenie pod fabryczne i niefabryczne radia",
      "Bezpieczniki i rozdzielnice wysokiej klasy",
      "Okablowanie najwyższej jakości",
    ],
    img: "https://images.unsplash.com/photo-1631844321841-f6e67698158f?q=80&w=1400&auto=format&fit=crop",
    span: "md:col-span-7",
  },
  {
    id: 1,
    tag: "Strojenie / 02",
    title: "Strojenie systemu",
    desc: "Konfiguracja zwrotnic, gainu i korekcji dźwięku dokładnie pod preferencje klienta.",
    features: [
      "Konfiguracja zwrotnic i gainu",
      "Korekcja dźwięku pod ucho klienta",
      "Bas dopasowany do wnętrza auta",
    ],
    img: "https://images.unsplash.com/photo-1603619890744-ed995cb96219?q=80&w=1400&auto=format&fit=crop",
    span: "md:col-span-5",
  },
  {
    id: 2,
    tag: "Akustyka / 03",
    title: "Wygłuszanie drzwi i auta",
    desc: "Redukcja szumów, poprawa akustyki i czystości dźwięku w całym pojeździe.",
    features: [
      "Maty butylowe: drzwi, bagażnik, podłoga",
      "Redukcja szumów i drgań blach",
      "Głębia i czystość dźwięku",
    ],
    img: "https://images.unsplash.com/photo-1546933751-ab7b6e888c66?q=80&w=1400&auto=format&fit=crop",
    span: "md:col-span-5",
  },
  {
    id: 3,
    tag: "Custom / 04",
    title: "Skrzynie na zamówienie",
    desc: "Budowa skrzyń custom idealnie dobranych pod parametry głośnika i geometrię bagażnika.",
    features: [
      "Typy Bass-Reflex i zamknięte",
      "Projekt pod parametry głośnika",
      "Dopasowanie do bagażnika 1:1",
    ],
    img: "https://images.unsplash.com/photo-1726248985986-20bef82d2b52?q=80&w=1400&auto=format&fit=crop",
    span: "md:col-span-7",
  },
];

const Card = ({ s, index }) => (
  <motion.a
    href="#kontakt"
    data-testid={`service-card-${s.id}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay: (index % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative block h-full overflow-hidden rounded-3xl border border-white/8 bg-surface transition-colors duration-500 hover:border-brand/60 ${s.span}`}
  >
    <img
      src={s.img}
      srcSet={`${s.img.replace("w=1400", "w=800")} 800w, ${s.img} 1400w`}
      sizes="(min-width: 768px) 60vw, 100vw"
      alt={s.title}
      loading="lazy"
      decoding="async"
      className="absolute inset-0 h-full w-full object-cover opacity-35 transition-all duration-700 group-hover:scale-105 group-hover:opacity-50"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/10" />
    <div className="relative flex min-h-[400px] md:min-h-[460px] h-full flex-col justify-end p-7 md:p-10">
      <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-brand">
        {s.tag}
      </span>
      <h3 className="mt-3 font-display text-3xl md:text-4xl font-semibold uppercase tracking-tight text-white">
        {s.title}
      </h3>
      <p className="mt-3 max-w-md text-sm md:text-base leading-relaxed text-zinc-400">
        {s.desc}
      </p>
      <ul className="mt-5 space-y-2.5">
        {s.features.map((f) => (
          <li
            key={f}
            className="flex items-start gap-3 text-sm text-zinc-300"
          >
            <Plus size={15} className="mt-0.5 shrink-0 text-brand" />
            {f}
          </li>
        ))}
      </ul>
      <div className="mt-7 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-500 transition-colors duration-300 group-hover:text-brand">
        Zapytaj o wycenę
        <ArrowUpRight
          size={16}
          className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </div>
    </div>
  </motion.a>
);

export default function Services() {
  return (
    <section id="uslugi" className="py-24 md:py-36" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <SectionHead
          eyebrow="Co robimy"
          title={
            <>
              Główne <span className="text-brand">usługi</span>
            </>
          }
          desc="Od pierwszego kabla po ostatnią decybelę stroju — wszystko w jednym miejscu."
        />
        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-12">
          {SERVICES.map((s, i) => (
            <Card key={s.id} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
